import { SuperModel, FieldConfig } from './super-model';

export class InternationalPhNumberModel extends SuperModel {
    additionalMetaData: MetadataBuilder = {};
    isReadonly: boolean;
    isHidden: boolean;
    fieldType: FieldType;
    fieldColumn: string;
    isRequired: boolean;
    constructor(
        field
        ) {
        super(field);
        this.additionalMetaData = field.additionalMetaData;
        if ([null, undefined].includes(this.additionalMetaData)) {
            this.additionalMetaData = {};
        }
        if (!this.additionalMetaData.hasOwnProperty('country')) {
            this.additionalMetaData.country = null;
        }
        if (!this.additionalMetaData.hasOwnProperty('showLabel')) {
            this.additionalMetaData.showLabel = true;
        }
        if (!this.additionalMetaData.hasOwnProperty('changeEventEmit')) {
            this.additionalMetaData.changeEventEmit = true;
        }
    }
}

type FieldType = 'internationalPhoneNumber';

interface MetadataBuilder {
    country?: string;
    showLabel?: boolean;
    fieldConfig?: FieldConfig;
    changeEventEmit?: boolean;
}
